module.exports = __webpack_public_path__ + "fonts/cash-market-rounded-medium.78f6a728.woff2";